module.exports = __webpack_public_path__ + "static/media/outlook-icon-black.162b2e84.svg";